<template>
  <div class="container shadow">
    <div class="row text-center">
      <div class="card ml-4" style="width: 22rem;">
        <div class="card-body">
          <h5 class="card-title">Personal Info</h5>
          <p class="card-text">{{ contact.name }}</p>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">{{ contact.email }}</li>
          <li class="list-group-item">{{ contact.Age }}</li>
          <li class="list-group-item">{{ contact.State }}</li>
          <li class="list-group-item">{{ contact.City }}</li>
          <li class="list-group-item">{{ contact.Address }}</li>
        </ul>
      </div>

      <div class="card ml-4" style="width: 22rem;">
        <div class="card-body">
          <h5 class="card-title">Business Info</h5>
          <p class="card-text">{{ contact.business_name }}</p>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">{{ contact.point_of_contact }}</li>
          <li class="list-group-item">{{ contact.poc_title }}</li>
          <li class="list-group-item">{{ contact.business_address }}</li>
          <li class="list-group-item">{{ contact.industry }}</li>
        </ul>
        <div class="card-body">
          <li class="list-group-item">{{ contact.reason }}</li>
        </div>
      </div>

      <div class="d-flex flex-column">
        <form @submit.prevent="prioritize(contact)">
          <input type="submit" class="btn btn-warning" value="Prioritize" />
        </form>

        <form @submit.prevent="">
          <v-btn
            class="text-white success"
            type="submit"
            small
            @click="createClient()"
            >Create Client</v-btn
          >
        </form>

        <form @submit.prevent="">
          <v-btn
            color="#E53935"
            class="text-white"
            type="submit"
            small
            @click="archive(contact)"
            >Archive</v-btn
          >
        </form>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contact: {},
      user: {}
    };
  },

  created() {
    this.singleContact();
    this.createUser();
  },

  methods: {

    createUser(){
      this.user = {
        name: this.contact.name,
        email: this.contact.email,
        company_name: this.contact.business_name,
        address: this.contact.Address,
        city: this.contact.City
      }
    },

    singleContact() {
      window.axios.get("api/contact/" + this.$route.params.id).then(res => {
        this.contact = res.data,
        this.createUser(res.data);
      });
    },

    prioritize(contact) {
      window.axios.post("api/prioritize/" + contact.id).then(() => {
        alert("Success");
      });
    },

    archive(contact) {
      window.axios.delete("api/archive/" + contact.id).then(() => {
        this.$swal('Success!', 'This user has been soft deleted.')
      });
    },

    createClient() {
      window.axios.post("/api/createClient", this.user).then(() => {
        this.user = {};
      });
    },
  }
};
</script>
<style scoped>
.classActive {
  background-color: rgb(15, 15, 15);
  border: 0;
}
</style>
